import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { CheckItem } from './ui/CheckItem';
import { GuaranteeLine } from './ui/GuaranteeLine';
import { ValueBreakdown } from './ui/ValueBreakdown';
import { BASE_CHECKOUT_URL, KIT_CHECKOUT_URL } from '../data/checkoutLinks';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
const baseIncludes = ['5 tomos especializados (250+ páginas)', 'Fichas de Pista (25 fichas)', 'Radar del Alumno', 'Semáforo de Correcciones Rápidas', 'Planificador 30 Días', 'Vuelta a Pista'];
const baseExcludes = ['Mapa de Pista (50 fichas) — solo en Kit', 'Programador 12 Meses — solo en Kit'];
const kitIncludes = ['5 tomos especializados (250+ páginas)', 'Fichas de Pista + Radar del Alumno', 'Semáforo de Correcciones Rápidas', 'Planificador 30 Días + Vuelta a Pista', 'Mapa de Pista — 50 fichas de ejercicio', 'Programador 12 Meses — temporada completa'];
export function PricingCards() {
  return <section id="oferta" className="bg-mp-black py-20 md:py-28 scroll-mt-20" data-id="element-209" data-mp="3ogia5sth20a6">
      <Container data-id="element-210" data-mp="3jji4hj0jazjl">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-211" data-mp="3jj05iemhm77z">
          <SectionTag tone="lime" data-id="element-212" data-mp="3fi6kpu4cd8jb">Oferta de lanzamiento</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-213" data-mp="g1qeub9verok">
            ¿Cuánto vale para ti recuperar tu tiempo?
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        ease: easeOut
      }} className="mx-auto mt-10 max-w-[700px] rounded-2xl border border-mp-border bg-mp-dark p-6 md:p-7" data-id="element-214" data-mp="6byhj9adzkge">
          <p className="font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-215" data-mp="u0q15c9wuuhk">
            ¿Cuál es la diferencia real entre las dos opciones?
          </p>
          <p className="mt-3 text-sm leading-relaxed text-mp-gray md:text-[15px]" data-id="element-216" data-mp="2t8gaain44lxw">
            La versión base te da los 5 tomos y las 5 herramientas para que nunca más improvises una clase. Es
            excelente para tener el sistema completo.
          </p>
          <p className="mt-3 text-sm leading-relaxed text-mp-gray md:text-[15px]" data-id="element-217" data-mp="2jh3j7t951zsx">
            El Kit de Ejecución añade el Mapa de Pista (50 fichas de ejercicios para consultar en 10 segundos) y el
            Programador 12 Meses (tu calendario de temporada de septiembre a junio). Por solo 5€ más, tienes la
            temporada entera resuelta al 100%.
          </p>
        </motion.div>

        <div className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-218" data-mp="20kkdldxjmu14">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut
        }} className="flex flex-col rounded-2xl border border-mp-border bg-mp-card p-7 md:p-8" data-id="element-219" data-mp="3q01ndpj7dp4m">
            <p className="font-heading text-lg uppercase tracking-wide text-mp-white" data-id="element-220" data-mp="1e9k5vfhad3a4">Maestro en Pista</p>
            <p className="mt-1 text-sm text-mp-gray" data-id="element-221" data-mp="1t2cirz59hzyj">Para aprender y aplicar el sistema</p>

            <ul className="mt-6 space-y-2.5" data-id="element-222" data-mp="1o7q6ltrcw3de">
              {baseIncludes.map(item => <CheckItem key={item} data-id="element-223" data-mp="21zej3y5iotuw">{item}</CheckItem>)}
              {baseExcludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-224" data-mp="1y1ysvzpsn034">
                  <XIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-mp-gray/50" strokeWidth={2.5} data-id="element-225" data-mp="2byvn8b54ezor" />
                  <span className="text-sm text-mp-gray/60 md:text-[15px]" data-id="element-226" data-mp="2713szah071he">{item}</span>
                </li>)}
            </ul>

            <div className="mt-8 flex-1" data-id="element-227" data-mp="cmjbf6nzbm28" />

            <ValueBreakdown lines={[{
            label: 'Colección 5 Tomos',
            value: '35,50€'
          }, {
            label: 'Los 5 Bonos Estratégicos',
            value: '25,50€'
          }]} totalLabel="Valor total" totalValue="61,00€" finalPrice="16,90 €" discountPercent="72%" priceTone="white" data-id="element-228" data-mp="cnkxs7ag3uz9" />

            <CTAButton href={BASE_CHECKOUT_URL} variant="secondary" className="w-full" showArrow data-id="element-229" data-mp="szehwzbounx0">
              Empezar con Maestro en Pista
            </CTAButton>
            <GuaranteeLine className="mt-4" data-id="element-230" data-mp="bimdxxuv21t" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: 0.05
        }} className="relative flex flex-col rounded-2xl border-2 border-mp-lime bg-mp-card p-7 shadow-glow-lime md:p-8" data-id="element-231" data-mp="9pdsd3om7r6">
            <span className="absolute -top-3 left-7 rounded-full bg-mp-lime px-3 py-1 font-heading text-[10px] font-bold uppercase tracking-wide text-mp-black" data-id="element-232" data-mp="3dpdmqzxfsgve">
              Lo elige el 80% de monitores
            </span>

            <p className="mt-2 font-heading text-lg uppercase tracking-wide text-mp-white" data-id="element-233" data-mp="1qse3c0gu23p7">
              Maestro en Pista + Kit de Ejecución
            </p>
            <p className="mt-1 text-sm text-mp-gray" data-id="element-234" data-mp="1guzqeau4bx1n">Incluye todo lo anterior, más:</p>

            <ul className="mt-6 space-y-2.5" data-id="element-235" data-mp="1bx7z9j1aseyi">
              {kitIncludes.map(item => <CheckItem key={item} data-id="element-236" data-mp="175zlybwuk9g2">{item}</CheckItem>)}
            </ul>

            <div className="mt-8 flex-1" data-id="element-237" data-mp="1344m7buke44e" />

            <ValueBreakdown lines={[{
            label: 'Todo lo anterior',
            value: '61,00€'
          }, {
            label: 'Kit de Ejecución',
            value: '25,90€'
          }]} totalLabel="Valor total" totalValue="86,90€" finalPrice="21,90 €" discountPercent="75%" priceTone="lime" data-id="element-238" data-mp="1355w3czugkkj" />
            <p className="-mt-4 mb-4 font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-239" data-mp="eizwd9940lpk">
              Solo 5 € más que la versión base
            </p>

            <CTAButton href={KIT_CHECKOUT_URL} className="w-full" showArrow data-id="element-240" data-mp="5jcu6l8k3bvg">
              Quiero el sistema completo
            </CTAButton>
            <GuaranteeLine className="mt-4" data-id="element-241" data-mp="9l6s4lrda1rx" />
          </motion.div>
        </div>

        <p className="mx-auto mt-10 max-w-[600px] text-center text-sm text-mp-gray" data-id="element-242" data-mp="xbaihrfjo50z">
          ⏳ Precio de lanzamiento — sube próximamente. Asegura el tuyo hoy.
        </p>
      </Container>
    </section>;
}